export default __webpack_public_path__ + "static/media/arrow-right-disabled.9327a7b7.svg";